import { render } from "./UserAvatarSpread.vue?vue&type=template&id=3dfd3bbe&scoped=true"
import script from "./UserAvatarSpread.vue?vue&type=script&lang=js"
export * from "./UserAvatarSpread.vue?vue&type=script&lang=js"

import "./UserAvatarSpread.vue?vue&type=style&index=0&id=3dfd3bbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3dfd3bbe"

export default script